<div class="rc-table">
  <div class="rc-table__row rc-table__row--header">
    @for (header of tableHeaders; track header) {
      <span class="rc-table__cell rc-table__cell--title">
        {{ header }}
      </span>
    }
  </div>

  <ng-content></ng-content>
</div>
